import { Alert, Stack } from "@mui/material"
import { If } from "lib/@components/switch"
import { getCurrencySymbol, formatMoney } from "../format-utils"

export function RateCardWarnings({ rateCard }) {
    if (!rateCard) return null

    const lines = rateCard.lines || []
    const hasLines = lines.length > 0
    const hasDefaultRate = rateCard.defaultRate > 0
    const hasSkillMapMappings = rateCard.skillMapId
    const allRatesZero = hasLines && lines.every(hasNoHourlyRate) && !hasDefaultRate

    return (
        <Stack spacing={1} sx={{ mt: 1 }}>
            <If value={!hasLines && !hasDefaultRate}>
                <Alert severity="warning">
                    This rate card has no trade rates. All tasks will use the default rate or remain unpriced.
                </Alert>
            </If>
            <If value={!hasLines && hasDefaultRate}>
                <Alert severity="info">
                    This rate card uses a default rate only. All trades priced at {getCurrencySymbol(rateCard.currency)}
                    {formatMoney(rateCard.defaultRate)}/hr.
                </Alert>
            </If>
            <If value={allRatesZero}>
                <Alert severity="warning">
                    All trade rates on this rate card are set to zero. The scenario will calculate zero costs.
                </Alert>
            </If>
            <If value={!hasSkillMapMappings}>
                <Alert severity="warning">No skill map is linked. All tasks will be unmapped.</Alert>
            </If>
        </Stack>
    )

    function hasNoHourlyRate(l) {
        if (l.mode === "fixed-annual") return !l.fixedAnnualAmount
        return !l.hourlyRate
    }
}
